export default "__VITE_ASSET__Bm_43tzQ__"